import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IBuilderDate } from '@shared/interfaces';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  standalone: false,
})
export class DateComponent implements OnInit {
  @Input() date: IBuilderDate;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  today: Date = new Date();

  ngOnInit(): void {
    console.log('got');

    if (this.date.isRequired) {
      this.control.setValidators([Validators.required]);
    }

    // Default value as current date
    if (this.date.disallowCurrentDate && !this.control.value) {
      this.control.setValue(this.today);
    }

    // Update validators based on restrictions
    if (this.date.isFutureDateSelected) {
      this.control.setValidators([
        ...(this.control.validator ? [this.control.validator] : []),
        (control) =>
          control.value && control.value < this.today
            ? { pastDateNotAllowed: true }
            : null,
      ]);
    }

    if (this.date.isPastDateSelected) {
      this.control.setValidators([
        ...(this.control.validator ? [this.control.validator] : []),
        (control) =>
          control.value && control.value > this.today
            ? { futureDateNotAllowed: true }
            : null,
      ]);
    }

    this.control.updateValueAndValidity();

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
